declare var $: any;

import { ReferenceHousesComponent } from "../components/referenceHousesComponent";

export class ProcurementModel {
    private static defaultProductId: number;

    static init(defaultProductId: number) {
        ProcurementModel.defaultProductId = defaultProductId;
        ProcurementModel.bindEvents();
        ProcurementModel.showPersistedSupplier();
        ProcurementModel.selectFirstBestHouseIfNoProcurementModelHasBeenSelected();
    }

    static selectFirstBestHouseIfNoProcurementModelHasBeenSelected() {
        if ($(".js-procurement-model-chooser input[type=radio]:checked").length === 0) {
            $($(".js-procurement-model-chooser input[type=radio]")[0]).trigger("click");
        }
    }

    static bindEvents() {
        ProcurementModel.toggleReferenceHouseGroups($(".js-reference-house-product:checked"));
        $(".js-reference-house-product").change(function () {
            ProcurementModel.toggleReferenceHouseGroups($(this));
            ReferenceHousesComponent.selectVisible();
        });

        $(".js-procurement-model-chooser input[type=radio]").on("change", ProcurementModel.showDefaultSupplier);
        ReferenceHousesComponent.init();

        ProcurementModel.bindRowEvents();
    }

    static bindRowEvents() {
        $(".js-add-row-button").off("click");
        $(".js-remove-row-button").off("click");

        $(".js-add-row-button").on("click", ProcurementModel.addRow);
        $(".js-remove-row-button").on("click", ProcurementModel.removeRow);
        $("form").on("submit", ProcurementModel.processListOfApartments);
    }

    static showDefaultSupplier() {
        ProcurementModel.updateChosenModelDetails(false);
    }

    static showPersistedSupplier() {
        ProcurementModel.updateChosenModelDetails(true);
    }

    static toggleReferenceHouseGroups($radio: any) {
        if ($radio.is(":checked")) {
            const id = $radio.val();
            $(`.js-reference-house-group[data-product-id=${id}]`).show();
            $(`.js-reference-house-group:not([data-product-id=${id}])`).hide();
        }
    }

    static updateChosenModelDetails(showPersistedState: boolean) {
        const $radio = $(".js-procurement-model-chooser input[type=radio]:checked");
        if ($radio.length === 0) {
            return;
        }

        const chosenType = $radio.val().toLowerCase();
        $(".js-model").slideUp(200);
        $(`.js-model--${chosenType}`).slideDown(200);

        if (showPersistedState) {
            // On initial load, we show the chosen product/supplier according to what the DB says
            return;
        }

        // If the user later clicks on another procurement model, we pre-select the default product/supplier
        ProcurementModel.preSelectProduct(chosenType);
    }

    static preSelectProduct(chosenType: string) {
        switch (chosenType) {
            case "flex":
                // If no ref house has been selected within Flex, then "Visa alla" should be selected
                if ($(".js-model--flex input[type=radio]:checked").length === 0) {
                    const $productRadio = $(".js-model--flex input[type=radio]:first");
                    $productRadio.prop("checked", true).trigger("change");

                    // find active radio group (carousel) and radio (slide)
                    const $houseRadioGroup = $(`.js-model--flex .js-reference-house-group[data-product-id=${$productRadio.val()}]`);
                    const $houseRadio = $(".item.active .js-reference-house-radio", $houseRadioGroup);
                    $houseRadio.prop("checked", true);
                }
                break;

            case "mini":
                // Pre-select the calculated default product, if any 
                if (ProcurementModel.defaultProductId > 0) {
                    $(`.js-model--mini input[type=radio][value=${ProcurementModel.defaultProductId
                        }].js-reference-house-product`)
                        .prop("checked", true)
                        .trigger("change");
                }
                break;

            case "custom":
                $(".js-model--custom input[type=radio]").prop("checked", true);
                break;
        }
    }

    static addRow(event: Event) {
        const tr = $(event.target).closest("tr");
        const originalTableCells = tr.html();

        // Append the new row using the correct floor type
        const floorType = tr.hasClass("js-apartment-row--ground") ? "ground" : "standard";
        const newRow = `<tr class='apartment-row js-apartment-row--${floorType} added'>${originalTableCells}</tr>`;
        $(newRow).insertAfter(tr);

        ProcurementModel.bindRowEvents();
    }

    static removeRow(event: Event) {
        const tr = $(event.target).closest("tr");
        tr.remove();
        ProcurementModel.bindRowEvents();
    }

    static numberOfExistingExtraRows(tr: any): number {
        return tr.closest("table")
            .find(`tr.js-apartment-row`).length;
    }

    static processListOfApartments() {
        if ($("input[type=radio][name=ProcurementModel][value=Custom]").is(":checked")) {
            $(".js-apartment-row--ground").each(ProcurementModel.assignNewListIndices);
            $(".js-apartment-row--standard").each(ProcurementModel.assignNewListIndices);
        }

        return true;
    }

    // To make sure all indeces are unique
    private static assignNewListIndices(idx: number, elem: Element) {
        $(elem).find("input, select")
            .each(
            function () {
                const currentName = $(this).attr("name");
                const newName = currentName.replace(/\[[0-9]+\]/, `[${idx}]`);
                $(this).attr("name", newName);
            }
            );
    }
}



// WEBPACK FOOTER //
// ./assets/scripts/partials/procurementModel.ts